// source: pbtypes/gen/run_modes/run_mode_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_run_modes_runmode_capabilities_pb = require('../../../pbtypes/gen/run_modes/runmode_capabilities_pb.js');
goog.object.extend(proto, pbtypes_gen_run_modes_runmode_capabilities_pb);
goog.exportSymbol('proto.run_modes.RunModeInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.run_modes.RunModeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.run_modes.RunModeInfo.repeatedFields_, null);
};
goog.inherits(proto.run_modes.RunModeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.run_modes.RunModeInfo.displayName = 'proto.run_modes.RunModeInfo';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.run_modes.RunModeInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.run_modes.RunModeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.run_modes.RunModeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.run_modes.RunModeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.run_modes.RunModeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
simulatorPublic: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
capabilitiesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.run_modes.RunModeInfo}
 */
proto.run_modes.RunModeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.run_modes.RunModeInfo;
  return proto.run_modes.RunModeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.run_modes.RunModeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.run_modes.RunModeInfo}
 */
proto.run_modes.RunModeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDisplayName(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSimulatorPublic(value);
      break;
    case 4:
      reader.readPackableEnumInto(msg.getCapabilitiesList());
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.run_modes.RunModeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.run_modes.RunModeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.run_modes.RunModeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.run_modes.RunModeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSimulatorPublic();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCapabilitiesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      4,
      f
    );
  }
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.run_modes.RunModeInfo.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.run_modes.RunModeInfo} returns this
 */
proto.run_modes.RunModeInfo.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.run_modes.RunModeInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.run_modes.RunModeInfo} returns this
 */
proto.run_modes.RunModeInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool simulator_public = 3;
 * @return {boolean}
 */
proto.run_modes.RunModeInfo.prototype.getSimulatorPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.run_modes.RunModeInfo} returns this
 */
proto.run_modes.RunModeInfo.prototype.setSimulatorPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated RunmodeCapabilities.Enum capabilities = 4;
 * @return {!Array<!proto.run_modes.RunmodeCapabilities.Enum>}
 */
proto.run_modes.RunModeInfo.prototype.getCapabilitiesList = function() {
  return /** @type {!Array<!proto.run_modes.RunmodeCapabilities.Enum>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<!proto.run_modes.RunmodeCapabilities.Enum>} value
 * @return {!proto.run_modes.RunModeInfo} returns this
 */
proto.run_modes.RunModeInfo.prototype.setCapabilitiesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!proto.run_modes.RunmodeCapabilities.Enum} value
 * @param {number=} opt_index
 * @return {!proto.run_modes.RunModeInfo} returns this
 */
proto.run_modes.RunModeInfo.prototype.addCapabilities = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.run_modes.RunModeInfo} returns this
 */
proto.run_modes.RunModeInfo.prototype.clearCapabilitiesList = function() {
  return this.setCapabilitiesList([]);
};


goog.object.extend(exports, proto.run_modes);
